import React from 'react'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'

type TopBarActionIconProps = Omit<
  React.ComponentProps<typeof ActionIcon>,
  'size' | 'children'
> & {
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  label: string
}

export const TopBarActionIcon = React.forwardRef<
  HTMLButtonElement,
  TopBarActionIconProps
>(({ icon, ...rest }, forwardedRef) => {
  return (
    <ActionIcon
      size="md"
      appearance="simple"
      theme="neutral"
      ref={forwardedRef}
      {...rest}
    >
      <Icon is={icon} />
    </ActionIcon>
  )
})
